import React, { useEffect, useState } from 'react';

const HoverMenu = ({ menuData, onClickRoute }) => {
    const [hoverIndex, setHoverIndex] = useState(null);

    const menuStyle = {
        display: "flex",
        gap: "20px",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "1200px",
        height: "56px",
        margin: "0 auto",
        padding: "20px",
        borderBottom: "1px solid #ddd"
    }

    const liStyle = {
        position: "relative"
    }

    const lnbStyle = {
        position: "absolute",
        zIndex: 999    
    }

    const lnbItemStyle = {
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        width: "max-content",
        padding: "0 30px"
    }

    const lnbItemItemStyle = {
        cursor: "pointer",
        margin: "20px 0"
    }

    const renderMenu = () => {
        return menuData.map((item, index) => {
            if (item.manage === false) return null;

            const isHovered = hoverIndex === index;

            return item.hasSub ? (
                <li
                    key={index}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                    className={isHovered ? 'selected' : ''}
                    style={liStyle}
                >
                    <a>{item.title}</a>
                    <div className='lnb' style={{ display: isHovered ? 'block' : 'none', ...lnbStyle }}>
                        <ul className='lnb-list' style={lnbItemStyle}>
                            {item.submenu.map((sub, subIndex) => (
                                <li
                                    key={subIndex}
                                    className="sub"
                                    onClick={() => onClickRoute(item.route, sub.route)}
                                    style={lnbItemItemStyle}
                                >
                                    {sub.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                </li>)
                :
                (<li onClick={() => onClickRoute("document", item.route)}>
                    <a>{item.title}</a>
                </li>
            );
        });
    };

    return <ul className="tab-menu" style={menuStyle}>{renderMenu()}</ul>;
};

export default HoverMenu;